<template>
  <div class="userCenter">
    <job-header-simple
      header_title="基本信息"
      :backRouter="backRouter"
    ></job-header-simple>
    <header>
      <div class="radius_cornor">
        <van-image
          width="1.9467rem"
          height="1.9467rem"
          fit="cover"
          :src="srcheader"
          class="header"
        />
        <div class="info">
          <p class="line_1">
            {{ user.name }}
            <span>{{ user.mobile }}</span>
          </p>
          <p class="line_2 van-ellipsis">{{ user.company }}</p>
        </div>
      </div>
    </header>
    <van-cell-group style="margin-bottom: 8px">
      <template v-for="item in papersTypeOptions">
        <van-cell
          class="item"
          title="证件类型"
          v-if="user.papersType == item.code"
          :value="item.value"
          :key="item.id"
        ></van-cell>
      </template>
       <van-cell  v-if="errorType===1" class="item" is-link  :to="{
          path:
            '/editPapers?type=3&contractId=' +
           $route.query.obj +
            '&employeeAccountId=' +
           user.id +
            '&ocompanyId=' +
           user.ocompanyId +
            '&usedBankAccount=' +
           user.bankAccount +
            '&papersType=' +
            user.papersType +
            '&username=' +
            user.username  +
            '&frontUrl=' +
            frontUrl +
            '&backUrl=' +
            backUrl 
        }" title="证件照片" value="识别有误?" value-class="red-text"></van-cell>
      <!-- <van-cell class="item" title="证件类型" v-if="user.papersType == '2'" value="护照"></van-cell> -->
      <van-cell class="item" title="证件号码" :value="user.idNumber"></van-cell>
       <van-cell class="item" is-link   v-if="errorType===2"   :to="{
          path:
            '/resetTel?type=3&contractId=' +
           $route.query.obj +
            '&employeeAccountId=' +
           user.id +
            '&ocompanyId=' +
           user.ocompanyId +
            '&usedBankAccount=' +
           user.bankAccount,
        }" title="手机号码" :value="user.mobile+'?'"  value-class="red-text"></van-cell>
    </van-cell-group>
    <van-cell-group style="margin-bottom: 8px">
      <van-cell class="item" title="性别">
        <span class="label_sex male active" v-if="user.gender == 1"></span>
        <span class="label_sex famale active" v-else></span>
        <!-- <van-radio-group v-model="user.sex">
                  <div class="item_radio">
                    <van-radio name="1" checked-color="#6c7ef3">
                      <span class="label_sex male"></span>
                    </van-radio>
                  </div>
                  <div class="item_radio">
                    <van-radio name="0" checked-color="#6c7ef3">
                      <span class="label_sex famale"></span>
                    </van-radio>
                  </div>
        </van-radio-group>-->
      </van-cell>
      <!-- <van-cell class="item" title="民族" :value="user.nation" is-link to></van-cell> -->
      <!-- <van-cell class="item" title="民族" :value="user.nation"></van-cell>-->
    </van-cell-group>
    <van-cell-group>
      <van-cell
        class="item"
        title="收款名称"
        :value="user.card_type"
      ></van-cell>
      <van-cell
      v-if="errorType===3"
        is-link
        :to="{
          path:
            '/card?type=3&contractId=' +
           $route.query.obj +
            '&employeeAccountId=' +
           user.id +
            '&ocompanyId=' +
           user.ocompanyId +
            '&usedBankAccount=' +
           user.bankAccount,
        }"
        class="item"
        title="收款账号"
        :value="user.card_id+'?'"
        value-class="red-text"
      ></van-cell>
         <van-cell
         v-else
        is-link
        :to="{
          path:
            '/card?type=0&contractId=' +
           $route.query.obj +
           '&employeeAccountId=' +
            this.user.id +
            '&ocompanyId=' +
            user.ocompanyId +
            '&usedBankAccount=' +
            user.bankAccount,
        }"
        class="item"
        title="收款账号"
        :value="user.card_id"
      ></van-cell>
    </van-cell-group>
     <template  v-if="!errorType">
        <van-cell
            class="item"
            title="身份验证"
            v-if="user.certificationStatus == 'AUTHENTICATIONOK'"
            >
            <!-- <span class=" text_theme">已认证</span> -->
            <van-button type="primary" size="mini">已认证</van-button>
        </van-cell>
        <van-cell v-else class="item" title="身份验证" @click="mouse">
        <!-- <span class="text_red">去认证</span> -->
        <van-button type="danger" size="mini">去认证</van-button>
        <span class="icon_finger animated infinite pulse"></span>
        </van-cell>
     </template>
  
    <template v-else>
        <van-cell class="item" title="身份验证" @click="mouseNew" >
        <!-- <span class="text_red">去认证</span> -->
        <van-button type="danger" size="mini">去认证</van-button>
        <span class="icon_finger animated infinite pulse"></span>
        </van-cell>
    </template>

    <div class="bottom">
        <div class="agreement-box">
            <van-checkbox
                name="1"
                class="text_gray agreement_line"
                checked-color="#6c7ef3"
                v-model="agreement"
                @change="setCheckBox"
                >同意</van-checkbox
            >
            <router-link to="/dianqianxieyi">《电签协议》</router-link>
            <div class="help-link" @click="showHelp = true">
                电签帮助
                <van-icon name="question"></van-icon>
            </div>
      </div>
      <van-button type="info" size="large" to class="btn_theme"  @click="sign"
        >开始电签</van-button
      >
    </div>

    <van-dialog v-model="showHelp">
      <div class="helpContent">
        <p>
          电子合同是双方或多方当事人之间通过电子信息网络以电子的形式达成的设立、变更、终止财产性民事权利义务关系的协议。
        </p>
        <p>
          依据《中华人民共和国电子签名法》 [2]
          第十四条：“可靠的电子签名与手写签名或者盖章具有同等的法律效力。”《电子签名法》对可靠的电子签名的规定是：“电子签名同时符合下列条件的，视为可靠的电子签名：
        </p>
        <p>1）电子签名制作数据用于电子签名时，属于电子签名人专有；</p>
        <p>2）签署时电子签名制作数据仅由电子签名人控制；</p>
        <p>3）签署后对电子签名的任何改动能够被发现；</p>
        <p>4）签署后对数据电文内容和形式的任何改动能够被发现；</p>
        <p>
          电子合同是当事人就一定的事件约定的双方权利义务归属了的文书，是电子合同履行的依据。电子合同有效的约定了合同双方或多方的权利和义务，对电子合同的履行有积极的作用，能够较为有效的约束违约行为，能够最大程度的保障自己的合法权利。
        </p>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import {
  Image,
  Cell,
  CellGroup,
  Button,
  NavBar,
  CheckboxGroup,
  Checkbox,
  Dialog,
  Toast,
  Icon,
} from 'vant'
import jobHeaderSimple from '@/components/header/header.vue'
import { goBack } from '@/utils/index.js'
import api from '@/api/list'
import { browserUA } from '@/utils/browserUA'
const srcheader = require('@/assets/user1.png')
export default {
  components: {
    [Image.name]: Image,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [Dialog.name]: Dialog,
    [Toast.name]: Toast,
    [Icon.name]: Icon,
    [Dialog.Component.name]: Dialog.Component,
    jobHeaderSimple,
  },
  data() {
    return {
      srcheader: srcheader
        ? srcheader
        : require('../../assets/img_default.png'),
      user: {},
      papersTypeOptions: [],
      showHelp: false,
      agreement: false,
      backRouter: '0',
      collectionMethod: 3, //收款方式
      polling: null, //轮询
      polling2:null,//轮询 第三方的认证
      polling3:null,//轮询 身份证
      polling3num:0,
      timerCount:0,
      isLoading:false,//第三方是否还在认证中
      errorType: null, //错误类型 1 实名认证-错误 2三要素手机号验证-错误 3三要素银行卡验证-错误 4其他错误信息 5第三方正在认证中
      errorMessage:'',//第三方返回的错误提示
      backUrl:'', //身份证反面照片
      isFirst: true,//是否是第一次加载
      frontUrl:''// 身份证正面照片
    }
  },
  // 回退页面问题
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.backRouter = '/contractList'
    })
  },
  beforeRouteLeave(to, from, next) {
    if (from.path == '/contractList') {
      this.$store.commit('SET_CHECKEDESIGN', false)
    }
    next()
  },
  created() {
  
    //获取登录人的信息
    this.$store.dispatch('getUserInfo')
    this.getPaperType()
    this.initActiveUserInfo()
    this.agreement = this.$store.getters.checkedEsign;
    if(this.$route.query.formPage=='face'){ //人脸识别 需要定时查询认证状态
        this.polling = setInterval(() => {
        this.init()
        }, 1000)
    }
    this.polling3 = setInterval(() => {
        if(this.polling3num >= 15){
            clearInterval(this.polling3);
            return
        }   
        this.polling3num++;
        this.initActiveUserInfo()
        }, 1000)

  },
  beforeDestroy() {
    // 清除所有定时器
    if (this.polling) {
      clearInterval(this.polling)
    }
    if (this.polling2) {
      clearInterval(this.polling2)
    }
    if (this.polling3) {
      clearInterval(this.polling3)
    }
  },
  methods: {
    //根据错误信息给返回的错误归类
    errorTypeClassify(errorMessage) {
      if (errorMessage.indexOf('实名认证-') > -1) {
        this.errorType = 1
      } else if (errorMessage.indexOf('三要素手机号验证-') > -1) {
        this.errorType = 2
      } else if (errorMessage.indexOf('三要素银行卡验证-') > -1) {
        this.errorType = 3
      } else if (errorMessage.indexOf('签约中')>-1){
            this.errorType = 5 
      } else{//其他错误 
            if(this.isFirst){
                let userId = this.$store.getters.userInfo.id;   
                this.$store.dispatch("doBosskgSign",{employeeAccountId: userId,contractEmployeeId:this.$route.query.obj}).then((res) => { 
                    console.log(res.data.reason);
                    if(res.data.reason&&res.data.reason.length>0){
                        this.errorTypeClassify(res.data.reason)
                    }else{
                         this.errorType = null;
                    }
                    
                }).catch((error) => {
                    this.errorType = 4     
                    this.errorMessage = errorMessage    
                }); 
                this.isFirst = false
            }else{
                this.errorType = 4     
                this.errorMessage = errorMessage    
            }
        }   
        if(this.errorType&&this.errorType===5){
         this.polling2 = setInterval(() => {
        this.queryAuthentication()
        }, 2000)
    }  
    },
    getPaperType() {
      api.getDataDictList({ group: 'papersType' }).then((response) => {
        this.papersTypeOptions = response.data.data
      })
    },
    setCheckBox(val) {
      this.$store.commit('SET_CHECKEDESIGN', val)
    },
    signContractUrl(url) {
      browserUA().then((browserType) => {
        if (browserType == 'androidAPP') {
          window.VpShopJs.signContract(JSON.stringify({ url: url }))
        } else {
          window.open(url, '_self')
        }
      })
    },
    sign() {
      if (this.agreement) {
        if (this.user.isEnabled) {
          //该银行卡已被经验
          Dialog.alert({
            title: '温馨提示',
            message: '该银行卡已被禁用，请选择其他银行卡！',
            confirmButtonText: '确认',
          })
          return
        }
        if (this.user.certificationStatus == 'AUTHENTICATIONOK') {
            if(this.errorType){
                this.$toast({
                    message: '请先完成实名认证！',
                })
                return
            }
          // 已认证
          if (
            typeof this.user.card_type != 'undefined' &&
            typeof this.user.card_id != 'undefined'
          ) { // 银行卡名称和银行卡账号不为空(协议绑定了银行卡)
        
            api
              .bank(
                {
                  name: this.user.card_type,
                  bankNo: this.user.card_id.replace(/\s/g, ''),
                  contractId: this.$route.query.obj,
                },
                { method: 'post' }
              )
              .then((res) => {
                if (res.data.status == '200') {
                  this.$store.commit('SET_CARDTYPE', undefined)
                  this.$store.commit('SET_CARDID', undefined)
                  if (this.user.signUrl != null) {
                    this.signContractUrl(this.user.signUrl)
                  } else {
                    // 向e签宝发起协议申请
                    this.createEmployeeContract({
                      id: this.$route.query.obj,
                    })
                  }
                }else{
                    this.$toast({
                        message: res.data.message,
                    })
                }
              })
          } else {
            this.$toast({
              message: '请先选择收款账号！',
            })
          }
        } else {
          this.$toast({
            message: '请先完成实名认证！',
          })
        }
      } else {
        this.$toast({
          message: '请勾选同意协议！',
        })
      }
    },
    //第三方认证不通过的跳转
    certificationUrl(){
        //1 实名认证-错误 2三要素手机号验证-错误 3三要素银行卡验证-错误
    switch (this.errorType) {
      case 1: // 实名认证错误
        // 跳转到身份验证页面
        this.$router.push({
          path: '/editPapers',
          query: {
            type: 3,
            employeeAccountId:this.user.id ,
            username: this.user.username,
            papersType: this.user.papersType,
            usedBankAccount: this.user.bankAccount,
            ocompanyId: this.user.ocompanyId,
            contractId: this.$route.query.obj,
            frontUrl:  this.frontUrl,
            backUrl: this.backUrl,
          }
        })
        break;
        
      case 2: // 三要素手机号验证错误
        // 跳转到修改手机号页面
        this.$router.push({
          path: '/resetTel',
          query: {
            type: 3,
            contractId: this.$route.query.obj,
            employeeAccountId:this.user.id ,
            ocompanyId: this.user.ocompanyId,
            usedBankAccount: this.user.bankAccount
          }
        })
        break;
        
      case 3: // 三要素银行卡验证错误
        // 跳转到修改银行卡页面
        this.$router.push({
          path: '/card',
          query: {
            type: 3,
            employeeAccountId:this.user.id ,
            contractId: this.$route.query.obj,
            ocompanyId: this.user.ocompanyId,
            usedBankAccount: this.user.bankAccount
          }
        })
        break;
        
      default:
        // 如果没有匹配的错误类型，执行默认操作，如调用原有的mouse方法
        this.mouse()
        break;
    }
    },
    mouseNew(){
        let errMassage = ''
        if (this.errorType===1) {
        errMassage = '您上传的身份证图片不清晰，请重新提交'
        }else if (this.errorType===2) {
        errMassage = '请重新绑定本人实名认证的手机号码'
        }else if (this.errorType===3) {
        errMassage = '收款账号认证失败，请重新选择或新增银行卡账户'
        }else if (this.errorType===4) {
        errMassage = this.errorMessage
        }
        if(errMassage.length>0){
            Dialog.alert({
            title: '温馨提示',
            message: errMassage,
            confirmButtonText: '去更新',
        }).then(() => {
            this.certificationUrl()
        })
        }
        if(this.errorType===5){ 
          Toast({
            message: '您修改的信息正在校验中\n请稍后刷新页面查看认证结果',
            duration: 5000, // 显示5秒
            forbidClick: true,
            onClose: () => {
                // 关闭时的回调
            }
            })
        }   
    },
    mouse() {
      if (!this.user.card_type || !this.user.card_id) {
        Dialog.alert({
          title: '提示',
          message: '请选择收款账号',
        }).then(() => {})
      } else {
        if (this.user.papersType !== '1') {
          this.$router.push({
            path: '/identity',
            query: {
              bankCard: this.user.card_id,
              bankName: this.user.card_type,
              bankMobile: this.user.card_phone,
              papersType: this.user.papersType,
              contractId: this.$route.query.obj,
              front: this.user.front, //身份证正面
              back: this.user.back, //身份证反面
              type: 'card',
            },
          })
        } else {
          if (
            'card' === this.user.cerficationTypes ||
            this.user.cerficationTypes === 'bankcard4' ||
            this.user.cerficationTypes === 'telecom3'
          ) {
            this.$router.push({
              path: '/identity',
              query: {
                bankCard: this.user.card_id,
                bankName: this.user.card_type,
                bankMobile: this.user.card_phone,
                contractId: this.$route.query.obj,
                front: this.user.front,
                back: this.user.back,
                type: this.user.cerficationTypes,
              },
            })
          } else if ('face' === this.user.cerficationTypes) {
            this.$router.push({
              path: '/identity',
              query: {
                bankCard: this.user.card_id,
                bankName: this.user.card_type,
                bankMobile: this.user.card_phone,
                contractId: this.$route.query.obj,
                front: this.user.front,
                back: this.user.back,
                bankCardId: this.user.bankCardId,
                type: this.user.cerficationTypes,
              },
            })
            // let param ={
            //       bankCardId: this.user.bankCardId,
            //       contractId: this.$route.query.obj
            // }
            // api.individualFace(param).then((res) => {
            //   if (res.status == '200') {
            //     let json = JSON.parse(res.data.data)
            //     if (json == null) {
            //       Toast.fail(res.data.message)
            //     } else {
            //       browserUA().then((browserType) => {
            //         if (browserType == 'androidAPP') {
            //           window.VpShopJs.bodyCheck(
            //             JSON.stringify({ url: json.url })
            //           )
            //         } else {
            //           location.href = json.url
            //         }
            //       })
            //     }
            //   } else {
            //     Toast.fail('发起认证失败')
            //   }
            // })
          } else {
            if (
              this.user.cerficationTypes === '' ||
              this.user.cerficationTypes === null
            ) {
              this.$router.push({
                path: '/identity',
                query: {
                  bankCard: this.user.card_id,
                  bankName: this.user.card_type,
                  bankMobile: this.user.card_phone,
                  contractId: this.$route.query.obj,
                  bankCardId: this.user.bankCardId,
                  front: this.user.front,
                  back: this.user.back,
                  type: 'bankcard4',
                },
              })
            } else {
              //判断选择的是银行卡还是支付宝，微信
              let arr = this.filterColumns()
              this.$router.push({
                path: '/identitySelection',
                query: {
                  front: this.user.front,
                  back: this.user.back,
                  bankCard: this.user.card_id,
                  bankName: this.user.card_type,
                  bankMobile: this.user.card_phone,
                  contractId: this.$route.query.obj,
                  bankCardId: this.user.bankCardId,
                  cerficationTypes: arr.join(','),
                },
              })
            }
          }
        }
      }
    },
    filterColumns() {
       this.collectionMethod = 1
      if (this.user.card_type.indexOf('支付宝') > -1) {
        this.collectionMethod = 2
      } else if (this.user.card_type.indexOf('微信') > -1) {
        this.collectionMethod = 3
      } 
      let authenticationMethodTypes = []
      if (this.user.cerficationTypes && this.user.cerficationTypes.length > 0) {
        authenticationMethodTypes = this.user.cerficationTypes.split(',')
      }
      if (this.collectionMethod != 1) {
        return authenticationMethodTypes.filter(
          (item) => item === 'telecom3' || item === 'face'
        )
      } else {
        return authenticationMethodTypes
      }
    },
    queryAuthentication(){
  
        this.timerCount++
      if (this.errorType!==5) {
        if( this.polling2){
            clearInterval(this.polling2)
        }
        return false
      }
  api.getReasonByEmployeeAndContract({ 
        contractId: this.$route.query.obj, 
        employeeAccountId: this.user.id 
        }).then((res) => {
        if (res.data.status === 200) {
            const { thirdErrorReason } = res.data;
            if(thirdErrorReason&&thirdErrorReason.length>0){
                this.errorTypeClassify(thirdErrorReason);
            }else{
                this.errorType = null;
            }
           
        } else {
            throw new Error(res.data.message || '未知错误'); // 主动抛出错误
        }
        })
    },
    init(){
        const toastLoading = Toast.loading({
        message: '正在认证中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0,
      })
      if( this.timerCount > 7){
            clearInterval(this.polling)
            toastLoading.clear()
              return false
      }
        this.timerCount++
      if (this.user.certificationStatus==='AUTHENTICATIONOK') {
        if( this.polling){
            toastLoading.clear()
            clearInterval(this.polling)
        }
        return false
      }
    api.employeeGetAllInfo({ contractId: this.$route.query.obj })
        .then((res) => {
                if(res.data.status == '200'){
                   this.user.certificationStatus = res.data.data.certificationStatus
                }
        }).catch(err=>{
             if( this.polling){
              clearInterval(this.polling)
             }
            toastLoading.clear() // 清除加载提示
            Toast.fail('认证失败，请重试') // 添加失败提示
        })
    },
    initActiveUserInfo() {
      api
        .employeeGetAllInfo({ contractId: this.$route.query.obj })
        .then((res) => {
          if (res.data.status == '200') {
            this.user = res.data.data
            if(this.user.thirdErrorReason&&this.user.thirdErrorReason.length>0){
                const {thirdErrorReason} = res.data.data;
                this.errorTypeClassify(thirdErrorReason)
            }else{
                this.errorType = null;
            }
            this.user.company = this.$route.query.name
            if (res.data.data.bankName != null) {
              this.user.card_type = res.data.data.bankName
              this.user.card_id = res.data.data.bankAccount
            } else {
              this.$store.commit('SET_CARDTYPE', undefined)
              this.$store.commit('SET_CARDID', undefined)
            }
            if (
                this.user.front != null &&
                this.user.front != '' &&
                this.user.front != undefined
            ) {
                 this.frontUrl = process.env.VUE_APP_FILE_PATH + this.user.front
            }
            if (
                this.user.back != null &&
                this.user.back != '' &&
                this.user.back != undefined
            ) {
                 this.backUrl = process.env.VUE_APP_FILE_PATH + this.user.back
            }
            if (
              res.data.data.headshot &&
              typeof res.data.data.headshot != 'undefined'
            ) {
              this.srcheader =
                process.env.VUE_APP_FILE_PATH + res.data.data.headshot
            }
            this.user.certificationStatus = res.data.data.certificationStatus
            if (
              this.$route.query.val != undefined &&
              this.$route.query.val != '' &&
              this.$route.query.val != null&&this.$route.query.val.bank_name
            ) {
              this.user.card_type = this.$route.query.val.bank_name
              this.user.card_id = this.$route.query.val.account
              this.user.bankCardId = this.$route.query.val.id
              this.user.card_phone = this.$route.query.val.bank_mobile
              if (this.$route.query.form && this.$route.query.form === 'card') {
                this.user.isEnabled = false
              }
            }
            if (this.user.card_type == undefined) {
              if (this.$store.getters.card_type != 'undefined') {
                this.user.card_type = this.$store.getters.card_type
              }
            } else {
              this.$store.commit('SET_CARDTYPE', this.user.card_type)
            }
            if (this.user.card_id == undefined) {
              if (this.$store.getters.card_id != 'undefined') {
                this.user.card_id = this.$store.getters.card_id
              }
            } else {
              this.$store.commit('SET_CARDID', this.user.card_id)
            }
          }
        })
    },
    goBack() {
      goBack()
    },
    createEmployeeContract(obj) {
      // 向e签宝发起协议申请
      const toastLoading = Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0,
      })
      api.createContract(obj, { method: 'post' }).then((res) => {
        toastLoading.clear() //关闭加载效果
        if (res.data.status == '200') {
          this.signContractUrl(res.data.data)
        } else {
          this.$toast({
            message: res.data.message,
          })
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.userCenter {

  header {
    padding: 10px 12px;
    .radius_cornor {
      display: -webkit-flex; /* Safari */
      display: flex;
      flex-wrap: nowrap;
      align-items: middle;
      padding: 16px;
      border-radius: 6px;
      background: #6c7ef3;
      background: -webkit-linear-gradient(to right, #6c7ef3, #b6c0ff);
      background: -o-linear-gradient(to right, #6c7ef3, #b6c0ff);
      background: -moz-linear-gradient(to right, #6c7ef3, #b6c0ff);
      background: linear-gradient(to right, #6c7ef3, #b6c0ff);
      .header {
        align-self: center;
        background: #ebecf4;
        background-size: 52px 45px;
        border-radius: 6px;
        overflow: hidden;
      }
      .info {
        align-self: center;
        margin-left: 16px;
        color: #fff;
        overflow: hidden;
        p {
          padding: 0;
          margin: 0;
          line-height: 28px;
          &.line_1 {
            font-size: 18px;
            span {
              font-size: 14px;
            }
          }
          &.line_2 {
            width: 200px;
            font-size: 12px;
          }
        }
      }
    }
  }

  .item {
    color: #333;
    overflow: visible;

    .van-icon-arrow {
      color: #ddd;
    }

    .van-cell__value {
      color: #333;
      overflow: visible;
      &.red-text{
        color: red;
      }
    }
  }

  .item_radio {
    display: inline-block;

    & + .item_radio {
      margin-left: 20px;
    }
  }

  .icon_finger {
    position: absolute;
    right: 40px;
    top: 7.5px;
    display: block;
    width: 46px;
    height: 68px;
    background: url('../../assets/finger.png') center center no-repeat;
    background-size: contain;
    z-index: 99;
  }

  .bottom {
    background: #fff;
    padding: 0 40px 40px;
    .agreement-box{
        display: flex;
        align-items: center;
        /deep/.van-checkbox__label{
            line-height: initial;
        }
    }
    .agreement_line {
      padding: 24px 0;
      font-size: 13px;
      display: flex;
      vertical-align: middle;
      align-items: center;
      /deep/ .van-checkbox__icon {
        display: inline-block;
        vertical-align: middle;
      }
    }

    a {
      font-size: 13px;
      color: #6c7ef3;
      display: inline-block;
      vertical-align: middle;
    }
  }
}

@-webkit-keyframes pulse {
  from {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }

  50% {
    -webkit-transform: scale3d(1.05, 1.05, 1.05);
    transform: scale3d(1.05, 1.05, 1.05);
  }

  to {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

@keyframes pulse {
  from {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }

  50% {
    -webkit-transform: scale3d(1.05, 1.05, 1.05);
    transform: scale3d(1.05, 1.05, 1.05);
  }

  to {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

.pulse {
  -webkit-animation-name: pulse;
  animation-name: pulse;
}

.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

.animated.infinite {
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
}

.help-link {
  display: inline-block;
  vertical-align: middle;
  color: #6c7ef3;
  font-size: 13px;
  text-align: right;
  //margin-left: 10px;
  /deep/ .van-icon {
    font-size: 16px;
    display: inline-block;
    vertical-align: middle;
    margin-left: 3px;
    margin-top: -3px;
  }
}

.helpContent {
  padding: 6px 10px 6px 12px;
  font-size: 12px;
  line-height: 16px;
  p {
    margin: 6px 0;
  }
}
</style>
<style lang="less">
.text_gray {
  .van-radio__label {
    color: #999;
  }
}
</style>
